import Vue from "vue";
import App from "./App";
import router from "./router";
import "babel-polyfill";
//公用方法
import util from "./common/util";
import common from "./common/common";
import Vuex from "vuex";
import store from "./store";
import VuevideoPlayer from "vue-video-player";
import "video.js/dist/video-js.css";
Vue.use(VuevideoPlayer);
import audio from "vue-mobile-audio";
Vue.use(audio);
// 地址选择器
import addressSelect from '@/components/common/common/addressSelect'
Vue.component('addressSelect',addressSelect)

//可以转化成formData、
Vue.http.options.emulateJSON = true;
Vue.http.options.headers = {
  'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
};
Vue.use(VuevideoPlayer);
//定义自定义指令-纯数字 /\D+/g
Vue.directive("numberOnly", {
  bind: function(el) {
    el.handler = function() {
      el.childNodes[1].value = el.childNodes[1].value.replace(/\D+/g, ""); //因为是elementui组件里使用的el.value获取不到我们输入的内容。然后我发现他的第一个孩子才是我们输入的手机号码的内容。
    };
    el.addEventListener("keyup", el.handler); //这里使用keyup。我开始用的input发现第一次输入拼音字母竟然是可以输入的。改成keyup就都不能输入非数字了
  },
  unbind: function(el) {
    el.removeEventListener("keyup", el.handler);
  }
});
//-数字加字母 /[\W]/g
Vue.directive("numberLetterOnly", {
  bind: function(el) {
    el.handler = function() {
      el.childNodes[1].value = el.childNodes[1].value.replace(/[\W]/g, "");
    };
    el.addEventListener("keyup", el.handler);
  },
  unbind: function(el) {
    el.removeEventListener("keyup", el.handler);
  }
});
// 深拷贝 $deepCopy
function deepClone(target) {
  let result;
  if (typeof target === 'object') {
      if (Array.isArray(target)) {
          result = [];
          for (let i in target) {
              result.push(deepClone(target[i]))
          }
      } else if(target===null) {
          result = null;
      } else if(target.constructor===RegExp){
          result = target;
      }else {
          result = {};
          for (let i in target) {
              result[i] = deepClone(target[i]);
          }
      }
  } else {
      result = target;
  }
  return result;
}
Vue.prototype.$deepCopy = deepClone
import globalFilter from "@/assets/js/common/globalFilter.js"; //引入公共的全局过滤器
Object.keys(globalFilter).forEach(key => {
  Vue.filter(key, globalFilter[key]);
});
function getHistoryDate(num = 0){
  // 获取几天前的日期
  let today = new Date()
  let date = globalFilter['timestampToDate'](today.setDate(today.getDate() - num))
  return date
}
Vue.prototype.$getHistoryDate = getHistoryDate

window.moment = require("moment");
Vue.prototype.$ajax = axios;
Vue.config.productionTip = false;

import "@/assets/js/index.js"; //引入index.js文件 token登录请求反应接口
//编辑器
import VueQuillEditor from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

//拖拽组件 satrt
import VueDND from "awe-dnd";
Vue.use(VueDND);
//拖拽组件 end
Vue.use(VueQuillEditor);
Vue.use(util);
Vue.use(common);
Vue.use(Vuex);
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js